export enum Anspruchshoehe {
    ZAHLKIND = 'ZAHLKIND',
    ZAEHLKIND = 'ZAEHLKIND',
    KEIN_ZAHL_ZAEHLKIND = 'KEIN_ZAHL_ZAEHLKIND',
    NUR_RUECKFORDERUNG = 'NUR_RUECKFORDERUNG',
    FESTSETZUNG_OHNE_ZAHLUNG = 'FESTSETZUNG_OHNE_ZAHLUNG',
}

export enum AnspruchshoeheText {
    ZAHLKIND = 'Zahlkind',
    ZAEHLKIND = 'Zählkind',
    KEIN_ZAHL_ZAEHLKIND = 'Kein Zahlkind, kein Zählkind',
    NUR_RUECKFORDERUNG = 'Nur Rückforderung',
    FESTSETZUNG_OHNE_ZAHLUNG = 'Festsetzung ohne Zahlung',
}
